import { atom, useRecoilState } from "recoil";
import React, { useEffect } from "react";
import { Checkbox, Icon, Menu } from "semantic-ui-react";

import { OptionsStore } from "./OptionsStore";

export const darkMode = atom({
  key: "darkMode",
  default: OptionsStore.restore().darkMode,
});

export function DarkModeToggle() {
  const [isDark, setDarkMode] = useRecoilState(darkMode);

  useEffect(() => {
    changeTheme(isDark);
    OptionsStore.save({ darkMode: isDark });
  }, [isDark]);

  return (
    <div id="dark-mode-toggle">
      <Menu secondary>
        <Menu.Item>
          <Icon name="sun" size="tiny" />
          <Checkbox
            toggle
            checked={isDark}
            onClick={() => setDarkMode(!isDark)}
          />
          <Icon name="moon" size="tiny" />
        </Menu.Item>
      </Menu>
    </div>
  );
}

export function changeTheme(darkMode) {
  const invert = document.querySelectorAll(".ui");

  const modal = document.querySelectorAll(".player-modal");
  const subtitles = document.querySelectorAll(".lyrics > .message");

  if (darkMode) {
    document.querySelector("body").style.backgroundColor = "#1b1c1d";

    invert.forEach((e) => e.classList.add("inverted"));
    modal.forEach((e) => e.classList.add("modal-dark-mode"));
    subtitles.forEach((e) => e.classList.add("lyrics-dark-mode"));
  } else {
    document.querySelector("body").style.backgroundColor = "";

    invert.forEach((e) => e.classList.remove("inverted"));
    modal.forEach((e) => e.classList.remove("modal-dark-mode"));
    subtitles.forEach((e) => e.classList.remove("lyrics-dark-mode"));
  }
}
